<!-- Confirm to close an unsaved report -->
<p-dialog
    [visible]="isClosingConfirmationVisibleState()"
    [modal]="true"
    [closable]="false"
    header="Warning, Unsaved Changes!"
    class="save-warning-dialog">
    <span class="flex align-items-center">
        <i class="pi pi-exclamation-circle"></i>
        Do you want to save the changes to your report? {{ originalReport().name }}
    </span>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end">
            <button
                pButton
                label="Cancel"
                (click)="cancelCloseUnsaved()"
                class="p-button-secondary p-button-text"></button>
            <button
                pButton
                label="Close Without Saving"
                icon="pi pi-times"
                iconPos="right"
                (click)="closeUnsavedTab(false)"
                class="p-button-danger"></button>
            <button
                pButton
                [autofocus]="true"
                label="Save"
                icon="pi pi-save"
                iconPos="right"
                (click)="closeUnsavedTab(true)"
                class="p-button-primary"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Save a report -->
<p-dialog
    [visible]="isSavingConfirmationVisibleState()"
    [modal]="true"
    class="save-report-dialog"
    [closable]="false"
    [draggable]="false">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">Save Report</span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="file-save">
            <div class="file-info">
                <label
                    class="flex gap-1"
                    for="save__input-name"
                    >Name<span class="text-red-500">*</span></label
                >
                <input
                    #inputName
                    id="save__input-name"
                    class="w-full"
                    type="text"
                    placeholder="Please name report"
                    pInputText
                    [(ngModel)]="reportDataForSaving().name"
                    (click)="inputName.select()" />
                <p class="top-16">Description</p>
                <textarea
                    placeholder="Enter text describing this report"
                    class="w-full h-full"
                    rows="5"
                    cols="30"
                    pTextarea
                    [(ngModel)]="reportDataForSaving().description">
                </textarea>
            </div>
            <div class="file-info">
                <shared-dialog-user-folders
                    (selectedFolderId)="setSelectedFolder($event)"
                    [reportOrScheduledId]="originalReport().reportId ?? ''"></shared-dialog-user-folders>
            </div>
        </div>
        <div class="top-16 share">
            <div class="share-checkbox flex gap-4">
                <p-checkbox
                    inputId="share"
                    [binary]="true"
                    [(ngModel)]="reportDataForSaving().shared"
                    [disabled]="isReportReferencedInOthersSchedule$() ? ((isReportReferencedInOthersSchedule$() | async) ?? false) : false" />
                <label for="share">Share</label>
                @if (isReportReferencedInOthersSchedule$() | async) {
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-clock text-yellow-500"></i>
                        <p>Your report is being used by another user's schedule. Please reach out to admin to unshare your report</p>
                    </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button
            label="Cancel"
            [text]="true"
            severity="secondary"
            (click)="cancelCloseUnsaved()">
        </p-button>
        @if (originalReport().isOwner || originalReport().isOwner === undefined) {
            <p-button
                iconPos="right"
                icon="pi pi-save"
                (click)="save()"
                label="Save"
                [disabled]="isSaveDisabled">
            </p-button>
        }
        @if (originalReport().isOwner !== undefined) {
            <p-button
                iconPos="right"
                icon="pi pi-save"
                (click)="saveAs()"
                label="Save as New"
                [disabled]="isSaveAsDisabled">
            </p-button>
        }
    </ng-template>
</p-dialog>
